import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App';

import 'bootstrap/dist/css/bootstrap.css';
import './style/theme.css';

import './style/style.css';
import './style/fonts.css';
import './style/awesome-bootstrap-checkbox.css';

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx